import { render } from "./doctorwidget.vue?vue&type=template&id=4b64fc6e"
import script from "./doctorwidget.vue?vue&type=script&lang=js"
export * from "./doctorwidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__